import { GetterTree } from "vuex";
import { RootState } from "@service/store/types/RootState";
import { RoutingState } from "@service/store/types/RoutingState";

const getters: GetterTree<RoutingState, RootState> = {
    getByRouteName: state => (routeName: string) => {
        return state.froms.find(item => item.routeName == routeName);
    },
    getBackLink: state => (routeName: string, defaultValue = '') => {
        const element = state.froms.find(item => item.routeName == routeName);
        if (element && element.routeFromName) {
            return element.routeFromName;
        }
        return defaultValue;
    }
};

export {getters}